import React from 'react';
import { Tag } from 'tea-component';
import AIGenerated from '@op/assets/svg/ai-generated.svg';
import useLanguage from '@op/hooks/useLanguage';
import BubbleCommon, { TipsMapType } from '@op/components/BubbleCommon';
import './index.scss';

const aiGeneratedTipsMap: TipsMapType = {
  en: 'This label is retrieved directly from the platform page and indicates that the post’s audio or visuals were modified or fully generated using AI. Currently supported on X (Twitter) and YouTube only.',
  zh: '该标签直接获取自平台页面，表示帖子中的声音或画面经过 AI 加工或完全由 AI 生成。目前仅支持 X（Twitter）和 YouTube。',
};

export default function AIGeneratedTag({
  className = '',
}: {
  className?: string;
}) {
  const { formatMessage } = useLanguage();
  return (
    <BubbleCommon tipsMap={aiGeneratedTipsMap} showIcon={false} placement="top">
      <Tag className={`dbo-ai-generated-tag ${className}`}>
        <img src={AIGenerated} className="dbo-ai-generated-tag-icon" />
        {formatMessage({ id: 'AI-generated' })}
      </Tag>
    </BubbleCommon>
  );
}
